import { useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form'

import { useOrderFormCalculation } from '../../hooks/use-order-form-calculation.hook'

import {
  useOrderFormStore,
  useOrderFormStoreActions,
} from '../../stores/order-form.store'
import useOrderFormParams from '../../hooks/use-order-form-params.hook'

export type PaymentFormData = {
  formaPagto: string
	fkCondPagto: string
  payment01: string
  payment02: string
  payment03: string
  payment04: string
  payment05: string
  payment06: string
  payment07: string
  payment08: string
  payment09: string
  payment10: string
  payment11: string
  payment12: string
  payment13: string
  payment14: string
  payment15: string
  payment16: string
  payment17: string
  payment18: string
  payment19: string
  payment20: string
  payment21: string
  payment22: string
  payment23: string
  payment24: string
}

export const usePayment = () => {
  const { jsonOrderForm, isCalculationOrder, paramsOrderForm } = useOrderFormStore()
  const { calculateOrderForm } = useOrderFormCalculation()
  const { autoCalculateEnabled } = useOrderFormParams()
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null)

  const form = useForm<PaymentFormData>({
    values: {
			fkCondPagto: jsonOrderForm?.fkCondPagto,
      formaPagto: jsonOrderForm?.formaPagto,
      payment01: jsonOrderForm?.condPagto1,
      payment02: jsonOrderForm?.condPagto2,
      payment03: jsonOrderForm?.condPagto3,
      payment04: jsonOrderForm?.condPagto4,
      payment05: jsonOrderForm?.condPagto5,
      payment06: jsonOrderForm?.condPagto6,
      payment07: jsonOrderForm?.condPagto7,
      payment08: jsonOrderForm?.condPagto8,
      payment09: jsonOrderForm?.condPagto9,
      payment10: jsonOrderForm?.condPagto10,
      payment11: jsonOrderForm?.condPagto11,
      payment12: jsonOrderForm?.condPagto12,
      payment13: jsonOrderForm?.condPagto13,
      payment14: jsonOrderForm?.condPagto14,
      payment15: jsonOrderForm?.condPagto15,
      payment16: jsonOrderForm?.condPagto16,
      payment17: jsonOrderForm?.condPagto17,
      payment18: jsonOrderForm?.condPagto18,
      payment19: jsonOrderForm?.condPagto19,
      payment20: jsonOrderForm?.condPagto20,
      payment21: jsonOrderForm?.condPagto21,
      payment22: jsonOrderForm?.condPagto22,
      payment23: jsonOrderForm?.condPagto23,
      payment24: jsonOrderForm?.condPagto24,
    },
  })
  const { setIsCalculationOrder, setJsonOrderForm } = useOrderFormStoreActions()

		const formasPagto = paramsOrderForm.listaFormaPagto;

  const orderFactor = jsonOrderForm?.tipoFaturamento?.fator
  const orderFactorIsLow = orderFactor === 0
  const orderFactorIsFull = orderFactor === 100
  const { isViewOrder, isDisabledSecondColumn } = useOrderFormParams()

  const handleChangeValues = (fieldInJson: string, valueToInsert: unknown) => {
    const newJsonOrderForm = {
      ...jsonOrderForm,
      [fieldInJson]: valueToInsert,
    }

    setJsonOrderForm(newJsonOrderForm)

    if (autoCalculateEnabled) {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current)
      }

      debounceTimeout.current = setTimeout(() => {
        if (!isCalculationOrder) setIsCalculationOrder(true)
        calculateOrderForm(newJsonOrderForm)
      }, 750)
    }
  }

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current)
      }
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return {
		form,
		isViewOrder,
		orderFactorIsLow,
		orderFactorIsFull,
		handleChangeValues,
		isDisabledSecondColumn,
		paramsOrderForm,
		formasPagto
	};
}
